export const formatGeneratedLyrics = (rawText: string): string => {
  if (!rawText) return '';

  const formatted = rawText.replace(
    /"(.*?)"\s*:\s*"([\s\S]*?)",?\s*(?=\n|$)/g,
    (_, section, text) => {
      const title = section.charAt(0).toUpperCase() + section.slice(1);

      const cleanText = text.replace(/\\n/g, '\n');

      return `\n[${title}]\n${cleanText}\n`;
    },
  );

  return formatted
    .replace(/,$/gm, '')
    .replace(/\n{3,}/g, '\n\n')
    .trim();
};
